/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const KEY_VALUE_SEPARATOR = ";";

export const transformStringifiedTagToKeyValueObject = (tag: string) => {
  const splitted = tag.split(KEY_VALUE_SEPARATOR);

  return {
    key: splitted[0],
    value: splitted[1] ?? "",
  };
};
